import clsx from 'clsx'
import { useEffect, useState } from 'react'
import 'swiper/element-bundle'
import { useSwiper } from 'swiper/react'

import { CaretIcon } from './CaretIcon'

interface CarouselPrevButtonProps {
  disabled?: boolean
  hidden?: boolean
  className?: string
}

export const CarouselPrevButton = ({ hidden, className }: CarouselPrevButtonProps) => {
  const [index, setIndex] = useState(0)
  const swiper = useSwiper()
  useEffect(() => {
    if (!swiper) return

    const handleSlideChange = () => {
      setIndex(swiper.activeIndex)
    }

    swiper.on('slideChange', handleSlideChange)
    return () => {
      swiper.off('slideChange', handleSlideChange)
    }
  }, [swiper])
  return (
    <button
      key={`prev-button-${index}`}
      className={clsx(
        'size-10 absolute pr-1 z-20 group disabled:cursor-not-allowed rounded-full bg-white hover:bg-[#D4D4D4] disabled:bg-[#9B9B9B] border-2 border-solid border-black flex justify-center items-center',
        hidden && 'hidden',
        className,
      )}
      onClick={() => swiper.slidePrev()}
    >
      <CaretIcon className="size-5 rotate-180" />
    </button>
  )
}
